import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const PASSWORD = 'password'
const CONFIRM = 'confirmPassword'

/**
 * Form model
 */
const formModel = () => {
  return {
    [PASSWORD]: {
      label: `${t('reset.new-password')}`,
      name: PASSWORD,
      required: true,
      type: 'password',
    },
    [CONFIRM]: {
      label: `${t('reset.confirm-password')}`,
      name: CONFIRM,
      required: true,
      type: 'password',
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [PASSWORD]: '',
  [CONFIRM]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [PASSWORD]: yup
      .string()
      .required(`${t('errors.required-error-message')}`)
      .min(8, `${t('errors.min-length-error-message', { minLength: 8 })}`)
      .matches(/[A-Z]/, `${t('errors.uppercase-error-message')}`)
      .matches(/[a-z]/, `${t('errors.lowercase-error-message')}`)
      .matches(/[0-9]/, `${t('errors.number-error-message')}`)
      .matches(/[^A-Za-z0-9]/, `${t('errors.special-char-error-message')}`),
    [CONFIRM]: yup.string().oneOf([yup.ref(PASSWORD), null], `${t('errors.must-match-error-message')}`),
  })

export default formModel
